import React from "react";

export const InputCheckForQualification = ({
  obj,
  headTitle,
  otherHeadTitles,
  title,
  id,
  getInput,
  remove,
}) => {
  return (
    <div className="checkBoxContainer">
      <label
        className="container"
        htmlFor={`defaultUnchecked${id}`}
        onChange={() => {
          const checked = obj[headTitle]?.indexOf(title) === -1;
          if (checked) {
            remove(headTitle, title);
          }

          obj[headTitle].forEach((element) => {
            remove(headTitle, element);
          });

          otherHeadTitles.forEach((headTitle) => {
            obj[headTitle].forEach((element) => {
              remove(headTitle, element);
            });
          });

          if (checked) {
            getInput(headTitle, title);
          }
        }}
        style={{
          fontSize: "16px",
          color: "#535252",
          paddingTop: "7px",
        }}
      >
        {title}
        <input
          type="checkbox"
          id={`defaultUnchecked${id}`}
          //defaultChecked={obj[headTitle]?.indexOf(title) !== -1 ? true : false}
          checked={obj[headTitle]?.indexOf(title) !== -1 ? true : false}
          onChange={() => {}}
        />
        <span className="checkmark"></span>
      </label>
    </div>
  );
};
